export const getMatchName = (
  homeTeam: string = "",
  awayTeam: string = "",
  dateString: string = ""
): string => `${homeTeam} @ ${awayTeam} - ${dateString}`;
